import React, { forwardRef } from 'react';

import Select, { SingleValue } from 'react-select';

import DropdownIndicator from '@/components/common/Dropdown/components/DropdownIndicator';
import { getBillingIntervals } from '@/utils/data-helpers/intervals';
import { GetBillingIntervalTypes } from '@/graphql/contracts/_generated_/getBillingIntervalTypes.query';
import { IntervalData } from '../BillingInterval.container';
import styles from './interval-selector.module.scss';

interface IIntervalSelector {
  handleChange: (value: SingleValue<IntervalData>) => void;
}

function IntervalSelector({ handleChange }: IIntervalSelector, ref: any) {
  return (
    <div className={styles['interval-selector-wrapper']}>
      <div className={styles['interval-selector-title']}>Update Billing Interval</div>
      <div className={styles.selector}>
        <Select
          ref={ref}
          options={getBillingIntervals()}
          className="ag-dropdown"
          classNamePrefix="ag-dropdown"
          components={{ DropdownIndicator }}
          onChange={handleChange}
          isSearchable={false}
          getOptionValue={(option: GetBillingIntervalTypes['billingIntervalTypes'][number]): string =>
            option.billingInterval}
          getOptionLabel={(option: GetBillingIntervalTypes['billingIntervalTypes'][number]): string =>
            option.formattedBillingInterval}
          menuPortalTarget={document.querySelector('body')}
        />
      </div>
    </div>
  );
}

export default forwardRef(IntervalSelector);